import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { AppConstants } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  constructor(private httpService: HttpService) { }

  getUserProfilesAlongWithRelatedData(id) {
    const query = 'PractitionerRole?_include=*&active=true&practitioner.identifier=' + id;
    return this.httpService.executeGETQueryWithParams(query);
  }

  getUserProfiles(id) {
    const query = 'PractitionerRole?_include=PractitionerRole:organization&practitioner.identifier=' + id;
    return this.httpService.executeGETQueryWithParams(query);
  }

  getUserPreferencesQuestionnaire() {
    const queryParams = 'Questionnaire?identifier=' + AppConstants.userPreferencesQuestionnaireIdentifier;
    return this.httpService.executeGETQueryWithParams(queryParams);
  }

  getUserPreferencesQuestionnaireResponseForProfile(profileId) {
    const queryParams = 'QuestionnaireResponse?subject=' + profileId;
    // Setting no to cache control
    return this.httpService.executeGETQueryWithParams(queryParams, true);
  }

  postDefaultValuesForSelectedProfile(resource) {
    return this.httpService.postFHIRResource(resource);
  }

  updateUserPreferencesQuestionnaireResponse(resource) {
    return this.httpService.updateFHIRResource(resource);
  }
}
